var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-list"},[_c('table',{staticStyle:{"padding-top":"5px"}},[_c('tbody',_vm._l((_vm.participants),function(user){return _c('tr',{key:user.id},[_c('td',{staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"img-msg",attrs:{"src":user.imageUrl}})]),_c('td',[_vm._v(_vm._s(user.name))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }